import { fetch, getApiOrigin } from '@lib/fetch';
import { getDefinedUrlSearchParams } from '@lib/util';

export function meGet() {
  return fetch('/v3/me', {
    method: 'GET',
  });
}

export function meUpdate(body) {
  return fetch('/v3/me', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function meDelete() {
  return fetch('/v3/me', {
    method: 'DELETE',
  });
}

export function userCreate(body) {
  return fetch('/v3/users', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function userCreateByAdmin(body) {
  return fetch('/v3/admin/users', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function userUpdate(id, body) {
  return fetch(`/v3/users/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function userGet(id, queryParams) {
  return fetch(`/v3/users/${id}?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function deleteUser(id) {
  return fetch(`/v3/users/${id}`, {
    method: 'DELETE',
  });
}

export function deleteUserByAdmin(id) {
  return fetch(`/v3/admin/users/${id}`, {
    method: 'DELETE',
  });
}

export function companiesGet(queryParams) {
  return fetch(`/v3/companies?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function availableCompaniesForAssessmentRequestGet(assessmentFormId) {
  return fetch(`/v3/assessment-form-requests/${assessmentFormId}/companies`, {
    method: 'GET',
  });
}

export function companiesGetByAdmin(queryParams) {
  return fetch(
    `/v3/admin/companies/list?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function usersGet(queryParams) {
  return fetch(`/v3/users?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function userGetAllFromRemovedCompanies(queryParams) {
  return fetch(
    `/v3/admin/users/list-by-removed-companies?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function userGetByAdmin(id) {
  return fetch(`/v3/admin/users/${id}`, {
    method: 'GET',
  });
}

export function userCompaniesGetAllByAdmin(id) {
  return fetch(`/v3/admin/users/${id}/companies/list`, {
    method: 'GET',
  });
}

export function impersonateUserByAdmin(id, queryParams) {
  return fetch(
    `/v3/admin/users/${id}/impersonate?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function userUpdateByAdmin(id, body) {
  return fetch(`/v3/admin/users/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function userPatchByAdmin(id, body) {
  return fetch(`/v3/admin/users/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function usersPatchByAdmin(body) {
  return fetch('/v3/admin/users/bulk-patch', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function productsGet(queryParams) {
  return fetch(`/v3/products?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function productListGet(queryParams) {
  return fetch(`/v3/products/list?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function productsCreatedForMeGet(queryParams) {
  return fetch(
    `/v3/products/created-for-me?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function companyProductsGet(companyId, queryParams) {
  return fetch(
    `/v3/companies/${companyId}/companies-products?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function adminGetCompanyProductsGet(companyId, queryParams) {
  return fetch(
    `/v3/admin/companies/${companyId}/companies-products?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function companiesFind(queryParams) {
  return fetch(`/v3/companies/find?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function companiesGetTableData(queryParams) {
  return fetch(
    `/v3/companies/table-data?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

// This route to remove usage
export function companyGet(id) {
  return fetch(`/v3/companies/${id}`, {
    method: 'GET',
  });
}

export function companyCreateUnScoped(body) {
  return fetch('/v3/admin/companies', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function companyUpdateExtended(id, body) {
  return fetch(`/v3/companies/${id}/extend`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function companyEsgGet(id) {
  return fetch(`/v3/company-esg-answers/${id}`, {
    method: 'GET',
  });
}

export function companyEsgPatch(id, body) {
  return fetch(`/v3/company-esg-answers/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function companyGetContactOptions(id) {
  return fetch(`/v3/companies/contact-options/${id}`, {
    method: 'GET',
  });
}

export function companyTechInsightsGetByAdmin(id) {
  return fetch(`/v3/admin/companies/${id}/list-tech-insights`, {
    method: 'GET',
  });
}

export function productCreate(body) {
  return fetch('/v3/products', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function productWithComponentsCreate(body) {
  return fetch('/v3/products/create-with-components', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function bulkCreateProducts(body) {
  return fetch('/v3/products/bulk-upload-nuvo', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function productCopy(body) {
  return fetch('/v3/products/copy', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function productRecalculateBadges(productId) {
  return fetch(`/v3/products/${productId}/recalculate-badges`, {
    method: 'PUT',
    body: JSON.stringify({}),
  });
}

export function productBadgesGet(productId) {
  return fetch(`/v3/products/${productId}/badges`, {
    method: 'GET',
  });
}

export function productGet(id) {
  return fetch(`/v3/products/${id}`, {
    method: 'GET',
  });
}

export function productUpdate(id, body) {
  return fetch(`/v3/products/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function productArchive(id) {
  return fetch(`/v3/products/${id}`, {
    method: 'DELETE',
  });
}

export function productBulkArchive(productIds) {
  return fetch('/v3/products/bulk-archive', {
    method: 'PUT',
    body: JSON.stringify(productIds),
  });
}

export function productBulkUnarchive(productIds) {
  return fetch('/v3/products/bulk-unarchive', {
    method: 'PUT',
    body: JSON.stringify(productIds),
  });
}

export function productBulkDelete(productIds) {
  return fetch('/v3/products/bulk-delete', {
    method: 'DELETE',
    body: JSON.stringify(productIds),
  });
}

export function productEcoFootprintGet(id) {
  return fetch(`/v3/products/${id}/eco`, {
    method: 'GET',
  });
}

export function productEcoFootprintPatch(id, body) {
  return fetch(`/v3/products/${id}/eco`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function uploadURLPost(body) {
  return fetch('/v3/files', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function supplyChainsGetDropdown(queryParams) {
  return fetch(
    `/v3/supplychains/list?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function supplyChainGet(id) {
  return fetch(`/v3/supplychains/${id}`, {
    method: 'GET',
  });
}

export function supplyChainGetUnscoped(id) {
  return fetch(`/v3/admin/supplychains/${id}`, {
    method: 'GET',
  });
}

export function supplyChainsGet(queryParams) {
  return fetch(`/v3/supplychains?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function supplyChainsGetUnscoped(queryParams) {
  return fetch(
    `/v3/admin/supplychains?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function claimGet(id) {
  return fetch(`/v3/claims/${id}`, {
    method: 'GET',
  });
}

export function fileGet(fileUrl) {
  return fetch(`/v3/files/${fileUrl}`, {
    method: 'GET',
  });
}

export function claimsGet(queryParams) {
  return fetch(`/v3/claims?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function claimsHistoryGet(claimId, queryParams) {
  return fetch(
    `/v3/claims/${claimId}/list-expired-versions?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function claimsOtherActiveGet(claimId, queryParams) {
  return fetch(
    `/v3/claims/${claimId}/list-active-versions?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function claimProducts(claimId, queryParams) {
  return fetch(
    `/v3/claims/${claimId}/list-products?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function adminClaimProducts(claimId, queryParams) {
  return fetch(
    `/v3/admin/claims/${claimId}/list-products?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function claimsGetAllRequest(queryParams) {
  return fetch(
    `/v3/admin/claims/list/request?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getAllClaims(queryParams) {
  return fetch(`/v3/claims?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function getAllClaimsAdmin(queryParams) {
  return fetch(`/v3/admin/claims?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function certificateBulkArchive(body) {
  return fetch('/v3/admin/claims/bulk-archive', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function certificateBulkUnArchive(body) {
  return fetch('/v3/admin/claims/bulk-unarchive', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function certificateBulkRemove(body) {
  return fetch('/v3/admin/claims/bulk-delete', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function certificateBulkRestore(body) {
  return fetch('/v3/admin/claims/bulk-restore', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function topClaimsGet(queryParams) {
  return fetch(
    `/v3/claims/list-top-claims?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function claimCommentsGet(claimId, companyId) {
  return fetch(
    `/v3/claims/list-comments?claimId=${claimId}&companyId=${companyId}`,
    {
      method: 'GET',
    },
  );
}

export function claimCommentsAdd({ claimId, content, companyId }) {
  return fetch('/v3/claims/add-comment', {
    method: 'POST',
    body: JSON.stringify({ claimId, content, companyId }),
  });
}

export function claimCommentsGetByAdmin(claimId) {
  return fetch(`/v3/admin/claims/list-comments?claimId=${claimId}`, {
    method: 'GET',
  });
}

export function claimCommentsAddByAdmin({
  claimId,
  content,
  companyId,
  isInternalNote,
}) {
  return fetch('/v3/admin/claims/add-comment', {
    method: 'POST',
    body: JSON.stringify({ claimId, content, companyId, isInternalNote }),
  });
}

export function createClaimByAdmin(body) {
  return fetch('/v3/admin/claims', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function claimCreate(body) {
  return fetch('/v3/claims', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function claimUpdate(id, body) {
  return fetch(`/v3/claims/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function claimDelete(id) {
  return fetch(`/v3/claims/${id}`, {
    method: 'DELETE',
  });
}

export function claimRequestForApproval(id) {
  return fetch(`/v3/claims/${id}/request`, {
    method: 'PUT',
    body: JSON.stringify({}),
  });
}

export function moveClaimToDraft(id) {
  return fetch(`/v3/claims/${id}/to-draft`, {
    method: 'PUT',
    body: JSON.stringify({}),
  });
}

export function approveClaim(id) {
  return fetch(`/v3/admin/claims/${id}/approve`, {
    method: 'PUT',
    body: JSON.stringify({}),
  });
}

export function notVerifiableClaim(id) {
  return fetch(`/v3/admin/claims/${id}/not-verifiable`, {
    method: 'PUT',
    body: JSON.stringify({}),
  });
}

export function rejectClaim(id) {
  return fetch(`/v3/admin/claims/${id}/reject`, {
    method: 'PUT',
    body: JSON.stringify({}),
  });
}

export function updateClaim(id, body) {
  return fetch(`/v3/admin/claims/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function claimGetByAdmin(id) {
  return fetch(`/v3/admin/claims/${id}`, {
    method: 'GET',
  });
}

export function standardsGet(queryParams) {
  return fetch(`/v3/standards?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function standardGet(id) {
  return fetch(`/v3/standards/${id}`, {
    method: 'GET',
  });
}

export function standardUpdateByAdmin(id, body) {
  return fetch(`/v3/admin/standards/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function standardCreateByAdmin(body) {
  return fetch('/v3/admin/standards', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function badgesGet() {
  return fetch('/v3/badges', {
    method: 'GET',
  });
}

export function companyBadgesGet(queryParams) {
  return fetch(`/v3/claims?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function badgeGet(id) {
  return fetch(`/v3/badges/${id}`, {
    method: 'GET',
  });
}

export function badgeUpdateByAdmin(id, body) {
  return fetch(`/v3/admin/badges/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function usersListToImpersonateGet(queryParams) {
  return fetch(
    `/v3/admin/users-to-impersonate?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function addUserCompanyByAdmin(body) {
  return fetch('/v3/admin/user-companies', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function availableCompaniesToAddToUserCompanies(userId) {
  return fetch(`/v3/admin/user-companies/available-companies/${userId}`, {
    method: 'GET',
  });
}

export function companiesListToSwitchGet() {
  return fetch('/v3/user-companies/companies-to-switch', {
    method: 'GET',
  });
}

export function userCompaniesListByAdmin(userId) {
  return fetch(`/v3/admin/user-companies/${userId}`, {
    method: 'GET',
  });
}

export function userCompaniesList(userId) {
  return fetch(`/v3/user-companies/${userId}`, {
    method: 'GET',
  });
}

export function requestMissingClaimInformation(claimId, body) {
  return fetch(`/v3/claims/${claimId}/request-missing-information`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function managementProductCategoryFieldsGet(queryParams) {
  return fetch(
    `/v3/admin/product-category-fields?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function managementProductCategoryFieldCreate(body) {
  return fetch('/v3/admin/product-category-fields', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function managementProductCategoryFieldUpdate(id, body) {
  return fetch(`/v3/admin/product-category-fields/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function managementProductCategoryFieldPatch(id, body) {
  return fetch(`/v3/admin/product-category-fields/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function managementProductCategoryFieldDelete(id) {
  return fetch(`/v3/admin/product-category-fields/${id}`, {
    method: 'DELETE',
  });
}

export function managementProductCategoryGet(id) {
  return fetch(`/v3/admin/product-categories/${id}`, {
    method: 'GET',
  });
}

export function managementProductCategoriesGet(queryParams) {
  return fetch(
    `/v3/admin/product-categories?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function managementProductCategoryCreate(body) {
  return fetch('/v3/admin/product-categories', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function managementProductCategoryPatch(id, body) {
  return fetch(`/v3/admin/product-categories/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function managementProductCategoryUpdate(id, body) {
  return fetch(`/v3/admin/product-categories/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function companyDocumentsGet(queryParams) {
  return fetch(
    `/v3/company-documents?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function companySharedDocumentsGet(queryParams) {
  return fetch(
    `/v3/company-documents/shared?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function companyDocumentsRequest(id) {
  return fetch(`/v3/company-documents/${id}/request`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function companyDocumentsCancelRequest(id) {
  return fetch(`/v3/company-documents/${id}/cancel-request`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function companyDocumentPatch(id, body) {
  return fetch(`/v3/company-documents/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function companyDocumentBulkArchive(documentIds) {
  return fetch('/v3/company-documents/bulk-archive', {
    method: 'PATCH',
    body: JSON.stringify(documentIds),
  });
}

export function companyDocumentBulkRestore(documentIds) {
  return fetch('/v3/admin/company-documents/bulk-restore', {
    method: 'PATCH',
    body: JSON.stringify(documentIds),
  });
}

export function companyDocumentMakePublic({ id, confirmation }) {
  return fetch('/v3/company-documents/make-public', {
    method: 'PATCH',
    body: JSON.stringify({ id, confirmation }),
  });
}

export function companyDocumentShare({ id, companyIds }) {
  return fetch(`/v3/company-documents/${id}/share`, {
    method: 'PUT',
    body: JSON.stringify(companyIds),
  });
}

export function companyDocumentDeleteRequest({ id, companyId }) {
  return fetch('/v3/company-documents/delete-request', {
    method: 'POST',
    body: JSON.stringify({ id, companyId }),
  });
}

export function companyDocumentBulkCreate(body) {
  return fetch('/v3/company-documents/bulk-create', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function companyDocumentGet(id) {
  return fetch(`/v3/company-documents/${id}`, {
    method: 'GET',
  });
}

export function companyDocumentsDownload(body) {
  return fetch('/v3/company-documents/download', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function companyDocumentsListShared(queryParams) {
  return fetch(
    [
      `${getApiOrigin()}/api/company-documents/shared?${getDefinedUrlSearchParams(queryParams)}`,
    ],
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingAttachLinkDocumentsV1(body) {
  return fetch(
    [
      `${getApiOrigin()}/api/cascade-tracing/transactions/attach-link-documents`,
    ],
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export function auditsGet(queryParams) {
  return fetch(`/v3/audits?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function auditsValidForRiskMitigationGet(queryParams) {
  return fetch(
    `/v3/audits/list-for-risk-mitigations?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function auditFindingCreate(body) {
  return fetch('/v3/audit-findings', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function auditFindingPatch(id, body) {
  return fetch(`/v3/audit-findings/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function auditFindingBulkRemove(body) {
  return fetch('/v3/audit-findings/bulk-remove', {
    method: 'DELETE',
    body: JSON.stringify(body),
  });
}

export function auditGet(id) {
  return fetch(`/v3/audits/${id}`, {
    method: 'GET',
  });
}

export function auditCreate(body) {
  return fetch('/v3/audits', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function auditVersionsGet(auditId, queryParams) {
  return fetch(
    `/v3/audits/${auditId}/versions?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function auditsUpdate(id, body) {
  return fetch(`/v3/audits/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function materialsGet(queryParams) {
  return fetch(`/v3/materials?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function claimToArchive(id) {
  return fetch(`/v3/claims/${id}/to-archive`, {
    method: 'PUT',
    body: JSON.stringify({}),
  });
}

export function allProductRecalculateBadges() {
  return fetch('/v3/products/recalculate-badges', {
    method: 'PATCH',
    body: JSON.stringify({}),
  });
}

export function companyPatch(id, body) {
  return fetch(`/v3/companies/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function companyPatchExtend(id, body) {
  return fetch(`/v3/companies/${id}/extend`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function companyLinkPatch(body) {
  return fetch('/v3/companies/link', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function companyCustomInformationPatch(id, body) {
  return fetch(`/v3/companies/${id}/custom-information`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function companyBulkArchive(body) {
  return fetch('/v3/companies/bulk-unlink', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function companyPatchByAdmin(id, body) {
  return fetch(`/v3/admin/companies/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function getCompliance(type) {
  return fetch(
    `${type ? `/v3/analytics/compliance/${type}` : '/analytics/compliance/'}`,
    {
      method: 'GET',
    },
  );
}

export function getLinkedCompaniesWithGeoJson() {
  return fetch('/v3/companies/linked-companies-with-geojson', {
    method: 'GET',
  });
}

export function productPatch(id, body) {
  return fetch(`/v3/products/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function productPatchRecyclability(id, body) {
  return fetch(`/v3/products/${id}/recyclability`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function productBulkPatch(body) {
  return fetch('/v3/products/bulk-patch', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function auditPatch(id, body) {
  return fetch(`/v3/audits/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function auditBulkPatch(body) {
  return fetch('/v3/audits/bulk-patch', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function auditBulkDelete(body) {
  return fetch('/v3/audits/bulk-delete', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function auditBulkArchive(auditIds) {
  return fetch('/v3/audits/bulk-archive', {
    method: 'PATCH',
    body: JSON.stringify(auditIds),
  });
}

export function auditMakePublic({ id, confirmation }) {
  return fetch('/v3/audits/make-public', {
    method: 'PATCH',
    body: JSON.stringify({ id, confirmation }),
  });
}

export function auditShare({ id, companyIds }) {
  return fetch(`/v3/audits/${id}/share`, {
    method: 'POST',
    body: JSON.stringify(companyIds),
  });
}

export function auditRequest(id) {
  return fetch(`/v3/audits/${id}/request`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function auditCancelRequest(id) {
  return fetch(`/v3/audits/${id}/cancel-request`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function claimBulkArchive(body) {
  return fetch('/v3/claims/bulk-archive', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function assessmentsGet(queryParams) {
  return fetch(
    `/v3/assessment-forms?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function assessmentRequestsGet(queryParams) {
  return fetch(
    `/v3/assessment-form-requests?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function assessmentRequestsGetByAdmin(companyId, queryParams) {
  return fetch(
    `/v3/admin/assessment-form-requests/${companyId}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function assessmentTemplateCreate(body) {
  return fetch('/v3/assessment-forms/template', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function assessmentCreate(body) {
  return fetch('/v3/assessment-forms', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function assessmentUpdate(id, { name, description, questions = [] }) {
  return fetch(`/v3/assessment-forms/${id}`, {
    method: 'PUT',
    body: JSON.stringify({ name, description, questions }),
  });
}

export function assessmentGet(id) {
  return fetch(`/v3/assessment-forms/${id}`, {
    method: 'GET',
  });
}

export function assessmentGetListAvailableOptions() {
  return fetch('/v3/assessment-forms/question-asset-link', {
    method: 'GET',
  });
}

export function assessmentCompanyGet(id, companyId, withoutOptions) {
  return fetch(
    `/v3/assessment-forms/${id}/company/${companyId}?withoutOptions=${!!withoutOptions}`,
    {
      method: 'GET',
    },
  );
}
export function assessmentQuestionGet(id, companyId, questionId) {
  return fetch(
    `/v3/assessment-forms/${id}/company/${companyId}/questions/${questionId}`,
    {
      method: 'GET',
    },
  );
}
export function assessmentRequestGet(id) {
  return fetch(`/v3/assessment-form-requests/${id}`, {
    method: 'GET',
  });
}

export function assessmentAnswerGetById(assessmentForm, questionId) {
  return fetch(
    `/v3/assessment-form-requests/${assessmentForm}/question/${questionId}`,
    {
      method: 'GET',
    },
  );
}

export function assessmentAddCompanies(assessmentId, companyIds) {
  return fetch(`/v3/assessment-forms/${assessmentId}/add-companies`, {
    method: 'POST',
    body: JSON.stringify(companyIds),
  });
}

export function assessmentRemoveCompanies(assessmentId, companyIds) {
  return fetch(`/v3/assessment-forms/${assessmentId}/remove-companies`, {
    method: 'DELETE',
    body: JSON.stringify(companyIds),
  });
}

export function assessmentRequestPatchByCompanyIds(assessmentId, body) {
  return fetch(`/v3/assessment-form-requests/${assessmentId}/bulk-patch`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function assessmentRequestPatchByCompanyId(
  assessmentId,
  companyId,
  body,
) {
  return fetch(`/v3/assessment-form-requests/${assessmentId}/${companyId}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function assessmentCompaniesGet(id, queryParams) {
  return fetch(
    `/v3/assessment-forms/${id}/companies?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function assessmentAnswer({ assessmentFormQuestionId, options = [] }) {
  return fetch('/v3/assessment-form-requests/answer-question', {
    method: 'POST',
    body: JSON.stringify({
      assessmentFormQuestionId,
      options,
    }),
  });
}

export function assessmentSubmit(id) {
  // return true
  return fetch(`/v3/assessment-forms/submit-assessment/${id}`, {
    method: 'PUT',
    body: JSON.stringify({}),
  });
}

export function assessmentApproveQuestionAnswer({
  assessmentFormId,
  assessmentFormQuestionId,
  requestCompanyId,
}) {
  return fetch('/v3/assessment-forms/approve-question-answer', {
    method: 'POST',
    body: JSON.stringify({
      assessmentFormId,
      assessmentFormQuestionId,
      requestCompanyId,
    }),
  });
}

export function assessmentDenyQuestionAnswer({
  assessmentFormId,
  assessmentFormQuestionId,
  requestCompanyId,
}) {
  return fetch('/v3/assessment-forms/deny-question-answer', {
    method: 'POST',
    body: JSON.stringify({
      assessmentFormId,
      assessmentFormQuestionId,
      requestCompanyId,
    }),
  });
}

export function assessmentBulkArchive(body) {
  return fetch('/v3/assessment-forms/bulk-archive', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function exportProducts(body) {
  return fetch('/v3/products/export', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function exportProductList(productIds) {
  return fetch(
    `/v3/products/export-list?${getDefinedUrlSearchParams({
      productIds,
    })}`,
    {
      method: 'GET',
    },
  );
}

export function assessmentGetListExistingLink(id, queryParams) {
  return fetch(
    `/v3/assessment-forms/${id}/list-existing-assets?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function formQuestionTemplatesGet() {
  return fetch('/v3/assessment-forms/question-templates', {
    method: 'GET',
  });
}

export function formQuestionTemplateCategoriesGetByAdmin() {
  return fetch('/v3/admin/question-templates/categories', {
    method: 'GET',
  });
}

export function formQuestionTemplatesGetByAdmin(queryParams) {
  return fetch(
    `/v3/admin/question-templates?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function questionTemplateDeleteBulkByAdmin(body) {
  return fetch('/v3/admin/question-templates', {
    method: 'DELETE',
    body: JSON.stringify(body),
  });
}

export function assessmentFormQuestionCommentsGet(
  assessmentFormQuestionId,
  requestCompanyId,
  markAsRead = false,
) {
  return fetch(
    `/v3/assessment-forms/list-question-comments?assessmentFormQuestionId=${assessmentFormQuestionId}&requestCompanyId=${requestCompanyId}&markAsRead=${markAsRead}`,
    {
      method: 'GET',
    },
  );
}

export function assessmentFormQuestionCommentAdd({
  assessmentFormQuestionId,
  content,
  requestCompanyId,
  repliedCommentId,
}) {
  return fetch('/v3/assessment-forms/add-question-comment', {
    method: 'POST',
    body: JSON.stringify({
      assessmentFormQuestionId,
      content,
      requestCompanyId,
      repliedCommentId,
    }),
  });
}

export function productStoryGet(shop, sku) {
  return fetch(`/v3/products/story?sku=${sku}`, {
    method: 'GET',
    headers: {
      shopid: shop,
    },
  });
}

export function styleStoryGet(shop, sku) {
  return fetch(`/v3/styles/story?sku=${sku}`, {
    method: 'GET',
    headers: {
      shopid: shop,
    },
  });
}

export function questionTemplateUpdateByAdmin(body) {
  return fetch('/v3/admin/question-templates', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function questionTemplateGetByAdmin(id) {
  return fetch(`/v3/admin/question-templates/${id}`, {
    method: 'GET',
  });
}

export function questionCategoryGetByAdmin(id) {
  return fetch(`/v3/admin/question-templates/categories/${id}`, {
    method: 'GET',
  });
}

export function questionCategoryUpdateByAdmin(body) {
  return fetch('/v3/admin/question-templates/categories', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function assessmentGetListAvailableOptionsByAdmin() {
  return fetch('/v3/admin/question-asset-link', {
    method: 'GET',
  });
}

export function productUpdateQrCodeTag(id) {
  return fetch(`/v3/products/${id}/qr-code-tag`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function notificationTriggersAdminGet(queryParams) {
  return fetch(
    `/v3/admin/notification-triggers?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function notificationTriggersAdminPatch(id, body) {
  return fetch(`/v3/admin/notification-triggers/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function notificationsSendTest(id, body) {
  return fetch(`/v3/admin/notification-triggers/${id}/send-test-notification`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function materialsAdminGet(queryParams) {
  return fetch(
    `/v3/admin/materials?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function materialsAdminPatch(id, body) {
  return fetch(`/v3/admin/materials/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function materialAdminGet(id) {
  return fetch(`/v3/admin/materials/${id}`, {
    method: 'GET',
  });
}

export function materialAdminUpdate(id, body) {
  return fetch(`/v3/admin/materials/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function materialAdminCreate(body) {
  return fetch('/v3/admin/materials/', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function riskAnalysisAdminAnalyzeRequest(body) {
  return fetch('/v3/admin/industry-risks/analysis', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function riskAnalysisAdminCreateRisk(body) {
  return fetch('/v3/admin/industry-risks/risk', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function riskAnalysisAdminUpdateRisk(id, body) {
  return fetch(`/v3/admin/industry-risks/risk/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function riskAnalysisAdminGetIndexes(queryParams) {
  return fetch(
    `/v3/admin/industry-risks/index?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function riskAnalysisAdminCreateIndex(body) {
  return fetch('/v3/admin/industry-risks/index', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function riskAnalysisAdminUpdateIndex(id, body) {
  return fetch(`/v3/admin/industry-risks/index/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function riskAnalysisAdminGetRiskMitigations(type, queryParams) {
  return fetch(
    `/v3/admin/industry-risks/mitigation/${type}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function riskAnalysisAdminCreateMitigation(type, body) {
  return fetch(`/v3/admin/industry-risks/mitigation/${type}`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function riskAnalysisAdminPatchMitigation(type, id, body) {
  return fetch(`/v3/admin/industry-risks/mitigation/${type}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function riskAnalysisAdminDeleteMitigation(type, id) {
  return fetch(`/v3/admin/industry-risks/mitigation/${type}/${id}`, {
    method: 'DELETE',
  });
}

export function riskAnalysisGetCountryGrossRisks(queryParams) {
  return fetch(
    `/v3/industry-risks/summary/gross??${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function riskAnalysisGetCountryIndexes(code) {
  return fetch(`/v3/industry-risks/indexes/${code}`, {
    method: 'GET',
  });
}

export function riskAnalysisGetLandscape(queryParams) {
  return fetch(
    `/v3/industry-risks/landscape?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getFacilityProcesses() {
  return fetch('/v3/facility-processes/drop-down', {
    method: 'GET',
  });
}

export function riskAnalysisGetCompany2CompanyRiskProfile(
  companyId,
  queryParams,
) {
  return fetch(
    `/v3/companies/${companyId}/risk-profiles?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function riskAnalysisGetRisks(queryParams) {
  return fetch(
    `/v3/industry-risks/risk?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function riskAnalysisMitigationCreateCustom(body) {
  return fetch('/v3/industry-risks/mitigation/custom', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function riskAnalysisCustomMitigationDelete(id) {
  return fetch(`/v3/industry-risks/mitigation/custom/${id}`, {
    method: 'DELETE',
  });
}

export function riskAnalysisCustomMitigationPatch(id, body) {
  return fetch(`/v3/industry-risks/mitigation/custom/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function platformFeaturesAdminGet() {
  return fetch('/v3/admin/platform-features', {
    method: 'GET',
  });
}

export function getCompaniesByPlatformFeatureId(featureId, queryParams) {
  return fetch(
    `/v3/admin/companies/list-by-platform-feature-id/${featureId}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function platformFeatureAdminGet(featureId) {
  return fetch(`/v3/admin/platform-features/${featureId}`, {
    method: 'GET',
  });
}

export function platformFeatureAdminPatch(id, body) {
  return fetch(`/v3/admin/platform-features/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function createWebshop(body) {
  return fetch('/v3/admin/webshops/', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function webshopsGet(queryParams) {
  return fetch(
    `/v3/admin/webshops/list?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function webshopsConstantsGet(queryParams) {
  return fetch(
    `/v3/admin/webshops/list-constants?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function webshopGet(id) {
  return fetch(`/v3/admin/webshops/${id}`, {
    method: 'GET',
  });
}

export function webshopUpdate(id, body) {
  return fetch(`/v3/admin/webshops/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function webshopRemove(id) {
  return fetch(`/v3/admin/webshops/${id}`, {
    method: 'DELETE',
  });
}

export function cascadeTracingPurchaseOrderCreate(body) {
  return fetch('/v3/cascade-tracing/orders/purchases', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function checkPurchaseOrderNumbers(body) {
  return fetch(
    '/v3/cascade-tracing/orders/purchases/check-purchase-order-numbers',
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export function checkSalesOrderNumbers(body) {
  return fetch('/v3/cascade-tracing/orders/sales/check-sales-order-numbers', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingPurchaseOrderEdit(id, body) {
  return fetch(`/v3/cascade-tracing/orders/purchases/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function productTransformationCreate(body) {
  return fetch('/v3/cascade-tracing/transactions/product-transformation', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function bulkProductTransformationCreate(body) {
  return fetch('/v3/cascade-tracing/transactions/bulk-product-transformation', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingSalesOrderCreate(body) {
  return fetch('/v3/cascade-tracing/orders/sales', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingSalesOrderEdit(id, body) {
  return fetch(`/v3/cascade-tracing/orders/sales/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingPurchaseOrdersGet(queryParams) {
  return fetch(
    `/v3/cascade-tracing/orders/purchases?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingInternalOrdersGet(queryParams) {
  return fetch(
    `/v3/cascade-tracing/orders/internal?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingOrderDelete(id, type) {
  return fetch(`/v3/cascade-tracing/orders/${id}?type=${type}`, {
    method: 'DELETE',
  });
}

export function cascadeTracingPurchaseOrdersGetByNodeAndSupplier(queryParams) {
  return fetch(
    `/v3/cascade-tracing/orders/purchases-by-node/?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingPurchaseOrderGet(purchaseOrderId) {
  return fetch(`/v3/cascade-tracing/orders/purchases/${purchaseOrderId}`, {
    method: 'GET',
  });
}

export function cascadeTracingTracingGetByPurchaseOrderId(id) {
  return fetch(`/v3/cascade-tracing/orders/trace/purchases/${id}`, {
    method: 'GET',
  });
}

export function cascadeTracingProductTracingGetByPurchaseOrderId(id) {
  return fetch(`/v3/cascade-tracing/orders/product-trace/purchases/${id}`, {
    method: 'GET',
  });
}

export function cascadeTracingNodeProductTraceInfoGet(id, queryParams) {
  return fetch(
    `/v3/cascade-tracing/transactions/tracing-node-product-trace/${id}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingSalesOrdersGet(queryParams) {
  return fetch(
    `/v3/cascade-tracing/orders/sales?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingSalesOrderGet(salesOrderId) {
  return fetch(`/v3/cascade-tracing/orders/sales/${salesOrderId}`, {
    method: 'GET',
  });
}

export function cascadeTracingProductTracingGetBySalesOrderId(id) {
  return fetch(`/v3/cascade-tracing/orders/product-trace/sales/${id}`, {
    method: 'GET',
  });
}

export function cascadeTracingProductTracingLineLinkGet(id, queryParams) {
  return fetch(
    `/v3/cascade-tracing/transactions/product-line-link/${id}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingProductTracingNodeProductTransformationGet(
  id,
  queryParams,
) {
  return fetch(
    `/v3/cascade-tracing/transactions/product-transformations/${id}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingLinkSalesOrder({
  purchaseOrderId,
  salesOrderId,
}) {
  return fetch('/v3/cascade-tracing/orders/link-sales-order', {
    method: 'POST',
    body: JSON.stringify({ purchaseOrderId, salesOrderId }),
  });
}

export function cascadeTracingUnlinkSalesOrder({
  purchaseOrderId,
  salesOrderId,
}) {
  return fetch('/v3/cascade-tracing/orders/unlink-sales-order', {
    method: 'POST',
    body: JSON.stringify({ purchaseOrderId, salesOrderId }),
  });
}

export function cascadeTracingTransactionNodeGet(nodeId, queryParams) {
  return fetch(
    `/v3/cascade-tracing/transactions/node/${nodeId}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingTransactionNodeGetUnscoped(nodeId, queryParams) {
  return fetch(
    `/v3/cascade-tracing/transactions/node-unscoped/${nodeId}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingTransactionLayerGet(queryParams) {
  return fetch(
    `/v3/cascade-tracing/transactions/layer?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingTransactionLinkGet(linkId) {
  return fetch(`/v3/cascade-tracing/transactions/link/${linkId}`, {
    method: 'GET',
  });
}

export function cascadeTracingAttachOrder(body) {
  return fetch('/v3/cascade-tracing/transactions/attach-order', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingAttachExistingOrder(body) {
  return fetch('/v3/cascade-tracing/transactions/attach-existing-order', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingAttachOrigin(body) {
  return fetch('/v3/cascade-tracing/transactions/attach-origin', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingAttachLinkDocuments(body) {
  return fetch(
    [
      `${getApiOrigin()}/api/cascade-tracing/transactions/attach-link-documents`,
    ],
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export function cascadeTracingAttachNodeDocument(body) {
  return fetch(
    [
      `${getApiOrigin()}/api/cascade-tracing/transactions/attach-node-documents`,
    ],
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export function cascadeTracingRemoveNodeDocument(body) {
  return fetch('/v3/cascade-tracing/transactions/remove-node-document', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingRemoveLinkDocument(body) {
  return fetch('/v3/cascade-tracing/transactions/remove-link-document', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingRemoveLinkDocuments(body) {
  return fetch(
    `${getApiOrigin()}/api/cascade-tracing/transactions/remove-link-documents`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export function cascadeTracingTracingGetBySalesOrderId(id) {
  return fetch(`/v3/cascade-tracing/orders/trace/sales/${id}`, {
    method: 'GET',
  });
}

export function cascadeTracingPurchaseOrderPatch(id, body) {
  return fetch(`/v3/cascade-tracing/orders/purchases/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingSalesOrderPatch(id, body) {
  return fetch(`/v3/cascade-tracing/orders/sales/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingAttachmentsGetBySalesOrderId(id) {
  return fetch(
    [`${getApiOrigin()}/api/cascade-tracing/orders/sales/${id}/attachments`],
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingAttachmentsGetByPurchaseOrderId(id) {
  return fetch(
    [
      `${getApiOrigin()}/api/cascade-tracing/orders/purchases/${id}/attachments`,
    ],
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingLinkOrderLineProduct(body) {
  return fetch('/v3/cascade-tracing/orders/order-line-product-linking', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingToggleArchiveOrders(body) {
  return fetch('/v3/cascade-tracing/orders/toggle-archive', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingPurchaseOrdersBulkPatch(body) {
  return fetch('/v3/cascade-tracing/orders/purchases/bulk-patch', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingSalesOrdersBulkPatch(body) {
  return fetch('/v3/cascade-tracing/orders/sales/bulk-patch', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function getInAppNotifications(queryParams) {
  return fetch(`/v3/notifications?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function changeNotificationStatus(id, body) {
  return fetch(`/v3/notifications/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function changeAllNotificationsStatus(body) {
  return fetch('/v3/notifications', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function productCategoriesGet(queryParams) {
  return fetch(
    `/v3/product-categories?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

// Wrapper for useSelectV2 compatibility - accepts body params but makes GET request
export function productCategoriesDropdownGet(bodyParams) {
  const { page, limit, ...rest } = bodyParams;
  return fetch(
    `/v3/product-categories?${getDefinedUrlSearchParams({ page, limit, ...rest })}`,
    {
      method: 'GET',
    },
  );
}

export function ListProductCategoriesForMapping() {
  return fetch('/v3/product-categories/allTypes', {
    method: 'GET',
  });
}

export function productCategoryGet(id, queryParams) {
  return fetch(
    `/v3/product-categories/${id}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function productCategoriesFieldValuesGet(productId, queryParams) {
  return fetch(
    `/v3/products/${productId}/category-fields-values?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function productCategoriesFieldsGet(queryParams) {
  return fetch(
    `/v3/product-category-fields?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function productPlacementsGet(queryParams) {
  return fetch(
    `/v3/product-placements?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function productPlacementsCreate(body) {
  return fetch('/v3/product-placements', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function managementProductionProcessesGet(queryParams) {
  return fetch(
    `/v3/admin/production-processes?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function managementFacilityProcessesGet(queryParams) {
  return fetch(
    `/v3/admin/facility-processes?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function managementFacilityProcessGet(id) {
  return fetch(`/v3/admin/facility-processes/${id}`, {
    method: 'GET',
  });
}

export function managementFacilityProcessUpdate(id, body) {
  return fetch(`/v3/admin/facility-processes/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function managementFacilityProcessCreate(body) {
  return fetch('/v3/admin/facility-processes/', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function createdNetworkProductsGet(id, queryParams) {
  return fetch(
    `/v3/companies/${id}/created-network-products?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function productLinking(body) {
  return fetch('/v3/products/link-product', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function purchaseOrderProductsGet() {
  return fetch('/v3/cascade-tracing/orders/purchases/products', {
    method: 'GET',
  });
}

export function salesOrderProductsGet() {
  return fetch('/v3/cascade-tracing/orders/sales/products', {
    method: 'GET',
  });
}

export function cascadeTracingParticipantsByOrderIds(body) {
  return fetch('/v3/cascade-tracing/orders/participants-by-orderIds', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function companyBulkLink(body) {
  return fetch('/v3/companies/bulk-link', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function deleteAuditableCompany(id) {
  return fetch(`/v3/auditable-companies/${id}`, {
    method: 'DELETE',
  });
}

export function certificatesGet(queryParams) {
  return fetch(
    `/v3/certifications?${getDefinedUrlSearchParams(queryParams)}`,
    {},
  );
}

export function createAuditableCompany(body) {
  return fetch('/v3/auditable-companies', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function auditableCompaniesGet(queryParams) {
  return fetch(
    `/v3/auditable-companies?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function validateCertificate(data) {
  return fetch('/v3/certifications/validate', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function availableCompaniesForAuditGet() {
  return fetch('/v3/auditable-companies/companies', {
    method: 'GET',
  });
}

export function companiesToAuditGet() {
  return fetch('/v3/auditable-companies/companies-to-audit', {
    method: 'GET',
  });
}

export function productCertificationsGet(id, queryParams) {
  return fetch(
    `/v3/products/${id}/certifications?${getDefinedUrlSearchParams(queryParams)}`,
    {},
  );
}

export function calculateSecondaryWeight(data) {
  return fetch('/v3/cascade-tracing/orders/product-kg-quantity', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function companyAssessmentGet(companyId, queryParams) {
  return fetch(
    `/v3/assessment-forms/request-company/${companyId}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function attachmentTemplateByAdmin(body) {
  return fetch([`${getApiOrigin()}/api/admin/attachment-templates`], {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function editAttachmentTemplateByAdmin(id, body) {
  return fetch([`${getApiOrigin()}/api/admin/attachment-templates/${id}`], {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function attachmentTemplatesGetByAdmin(queryParams) {
  return fetch(
    [
      `${getApiOrigin()}/api/admin/attachment-templates?${getDefinedUrlSearchParams(queryParams)}`,
    ],
    {
      method: 'GET',
    },
  );
}

export function attachmentTemplatesAggregateGet(queryParams) {
  return fetch(
    [
      `${getApiOrigin()}/api/attachment-templates/aggregate?${getDefinedUrlSearchParams(queryParams)}`,
    ],
    {
      method: 'GET',
    },
  );
}

export function attachmentTemplatesGet(queryParams) {
  return fetch(
    [
      `${getApiOrigin()}/api/attachment-templates?${getDefinedUrlSearchParams(queryParams)}`,
    ],
    {
      method: 'GET',
    },
  );
}

export function attachmentTemplatesPost(body) {
  return fetch([`${getApiOrigin()}/api/attachment-templates`], {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function attachmentTemplateGetByAdmin(id) {
  return fetch(
    [`${getApiOrigin()}/api/admin/attachment-templates/${id}/details`],
    {
      method: 'GET',
    },
  );
}

export function attachmentTemplateGet(id) {
  return fetch([`${getApiOrigin()}/api/attachment-templates/${id}/details`], {
    method: 'GET',
  });
}

export function attachmentTemplatePut(id, body) {
  return fetch([`${getApiOrigin()}/api/attachment-templates/${id}`], {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function attachmentTemplateArchive(id) {
  return fetch([`${getApiOrigin()}/api/attachment-templates/${id}/archive`], {
    method: 'POST',
  });
}

export function attachmentTemplateDefinedRulesGet(id, queryParams) {
  console.log(queryParams);
  return fetch(
    [
      `${getApiOrigin()}/api/attachment-templates/${id}/documents?${getDefinedUrlSearchParams(queryParams)}`,
    ],
    {
      method: 'GET',
    },
  );
}
export function sendNotificationToAssessmentRequestedCompany(
  assessmentFromId,
  requestCompanyId,
) {
  return fetch(
    `/v3/assessment-forms/${assessmentFromId}/notify-requested-company/${requestCompanyId}`,
    {
      method: 'PUT',
      body: '{}',
    },
  );
}

export function getQuestionsWithAnswers(companyId, queryParams) {
  return fetch(
    `/v3/companies/${companyId}/c2c-custom-questions?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}
export function answerC2CQuestion(companyId, body) {
  return fetch(`/v3/companies/${companyId}/c2c-custom-questions/answer`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
export function attachmentTemplateUpdatePreference(
  attachmentTemplatePreferenceId,
) {
  return fetch([`${getApiOrigin()}/api/attachment-templates/preference`], {
    method: 'PUT',
    body: JSON.stringify({
      attachmentTemplateId: attachmentTemplatePreferenceId
        ? attachmentTemplatePreferenceId
        : null,
    }),
  });
}

export function cascadeTracingOrderDownloadLinkDocuments(linkId) {
  return fetch(
    `/v3/cascade-tracing/transactions/download-link-documents/${linkId}`,
    {
      method: 'GET',
    },
  );
}
export function c2cDefaultQuestionsGetByAdmin(queryParams) {
  return fetch(
    `/v3/admin/c2c-default-questions?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function c2cDefaultQuestionByAdmin(body) {
  return fetch('/v3/admin/c2c-default-questions', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function c2cDefaultQuestionGetByAdmin(id) {
  return fetch(`/v3/admin/c2c-default-questions/${id}`, {
    method: 'GET',
  });
}

export function c2cDefaultQuestionEditByAdmin(id, body) {
  return fetch(`/v3/admin/c2c-default-questions/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function c2cDefaultQuestionBulkRemoveByAdmin(body) {
  return fetch('/v3/admin/c2c-default-questions/bulk-remove', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function c2cCustomQuestionsGet(queryParams) {
  return fetch(
    `/v3/companies/c2c-custom-questions/list?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function c2cCustomQuestion(body) {
  return fetch('/v3/companies/c2c-custom-questions', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function c2cCustomQuestionGet(id) {
  return fetch(`/v3/companies/c2c-custom-questions/${id}`, {
    method: 'GET',
  });
}

export function c2cCustomQuestionEdit(id, body) {
  return fetch(`/v3/companies/c2c-custom-questions/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function c2cCustomQuestionBulkRemove(body) {
  return fetch('/v3/companies/c2c-custom-questions/bulk-remove', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function getAllProductVariations() {
  return fetch('/v3/products/get-all-product-variations', {
    method: 'GET',
  });
}

export function meGetRights() {
  return fetch('/v3/me/rights', {
    method: 'GET',
  });
}

export function rolesRightsGetAll(queryParams) {
  return fetch(
    `/v3/admin/users/roles-rights?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function createRolesRights(body) {
  return fetch('/v3/admin/users/roles-rights', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function bulkDeleteRolesRights(body) {
  return fetch('/v3/admin/users/roles-rights/bulk-delete', {
    method: 'DELETE',
    body: JSON.stringify(body),
  });
}

export function getRights() {
  return fetch('/v3/admin/users/rights', {
    method: 'GET',
  });
}

export function getRoles() {
  return fetch('/v3/admin/users/roles', {
    method: 'GET',
  });
}

export function cascadeTracingOrderDownloadOrderDocuments(orderId, type) {
  return fetch(
    `/v3/cascade-tracing/transactions/download-order-documents/${orderId}?type=${type}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingOrderTypeList() {
  return fetch('/v3/cascade-tracing/orders/order-types', {
    method: 'GET',
  });
}

export function cascadeTracingCreateNewOrderType(body) {
  return fetch('/v3/cascade-tracing/orders/order-types', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingOrderTagList() {
  return fetch('/v3/cascade-tracing/orders/tags', {
    method: 'GET',
  });
}

export function cascadeTracingCreateNewOrderTag(body) {
  return fetch('/v3/cascade-tracing/orders/tags', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingVerifyDocument(tracingDocumentId) {
  return fetch(
    `/v3/cascade-tracing/transactions/verify-document/${tracingDocumentId}`,
    {
      method: 'POST',
      body: JSON.stringify({}),
    },
  );
}

export function cascadeTracingUnVerifyDocument(tracingDocumentId) {
  return fetch(
    `/v3/cascade-tracing/transactions/unverify-document/${tracingDocumentId}`,
    {
      method: 'DELETE',
      body: JSON.stringify({}),
    },
  );
}

export function cascadeTracingBulkRefreshCalculation(body) {
  return fetch('/v3/cascade-tracing/orders/bulk-refresh-calculation', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function adminListAllCategories(queryParams) {
  return fetch(
    `/v3/admin/impact-areas?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function adminGetCategories(queryParams) {
  return fetch(
    `/v3/admin/impact-areas?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getCategories(queryParams) {
  return fetch(`/v3/impact-areas?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function getCategory(id, fields = '') {
  return fetch(`/v3/impact-areas/${id}?${fields ? `fields=${fields}` : ''}`, {
    method: 'GET',
  });
}

export function adminGetCategory(id, fields = '') {
  return fetch(
    `/v3/admin/impact-areas/${id}?${fields ? `fields=${fields}` : ''}`,
    {
      method: 'GET',
    },
  );
}

export function getCategoryHierarchy(hierarchyId) {
  return fetch(`/v3/admin/impact-areas/${hierarchyId}/get-hierarchy`, {
    method: 'GET',
  });
}

export function createImpactArea(category) {
  return fetch('/v3/admin/impact-areas/', {
    method: 'post',
    body: JSON.stringify(category),
  });
}

export function updateImpactArea(category) {
  return fetch(`/v3/admin/impact-areas/${category.id}`, {
    method: 'put',
    body: JSON.stringify(category),
  });
}

export function deleteImpactArea(id, body = {}) {
  return fetch(`/v3/admin/impact-areas/${id}`, {
    method: 'DELETE',
    body: JSON.stringify(body),
  });
}

export function removedCompanyPatchByAdmin(id, body) {
  return fetch(`/v3/admin/companies-removed/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingOrdersByCompanyGetByAdmin(id, queryParams) {
  return fetch(
    `/v3/admin/companies/${id}/list-tracing-orders?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function updateC2CPermissions(body) {
  return fetch('/v3/admin/companies-2-companies', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingDetachOrder({
  purchaseOrderId,
  salesOrderId,
  tracingLinkId,
  tracingType,
  initialOrderId,
}) {
  return fetch('/v3/cascade-tracing/transactions/detach-existing-order', {
    method: 'POST',
    body: JSON.stringify({
      purchaseOrderId,
      salesOrderId,
      tracingLinkId,
      tracingType,
      initialOrderId,
    }),
  });
}

export function allowedOriginsGetAll(queryParams) {
  return fetch(
    `/v3/admin/allowed-origins/list?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function bulkDeleteAllowedOrigins(body) {
  return fetch('/v3/admin/allowed-origins/bulk-delete', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function createAllowedOrigin(body) {
  return fetch('/v3/admin/allowed-origins', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
export function getAllowedOrigin(id) {
  return fetch(`/v3/admin/allowed-origins/${id}`, {
    method: 'GET',
  });
}
export function deleteAllowedOrigin(id) {
  return fetch(`/v3/admin/allowed-origins/${id}`, {
    method: 'DELETE',
  });
}
export function updateAllowedOrigin(id, body) {
  return fetch(`/v3/admin/allowed-origins/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function getClassificationEntities() {
  return fetch('/v3/admin/classification-data-fields/entities', {
    method: 'GET',
  });
}

export function getClassificationImpactAreas(queryParams) {
  return fetch(
    `/v3/admin/classification-impact-areas?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getCompanyDataFields(queryParams) {
  return fetch(
    `/v3/admin/company-data-fields?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function createCompanyDataField(body) {
  return fetch('/v3/admin/company-data-fields', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function patchCompanyDataField(id, body) {
  return fetch(`/v3/admin/company-data-fields/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function getClassificationDataFields(queryParams) {
  return fetch(
    `/v3/admin/classification-data-fields?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function createClassificationImpactArea(body) {
  return fetch('/v3/admin/classification-impact-areas', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function bulkDeleteClassificationImpactArea(body) {
  return fetch('/v3/admin/classification-impact-areas/bulk-delete', {
    method: 'DELETE',
    body: JSON.stringify(body),
  });
}

export function patchClassificationImpactArea(id, body) {
  return fetch(`/v3/admin/classification-impact-areas/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function createFiberLot(body) {
  return fetch('/v3/fiber/lots', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function getFiberLotsByProductId(id, queryParams) {
  return fetch(
    `/v3/fiber/lots/by-product/${id}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getFiberLots(queryParams) {
  return fetch(`/v3/fiber/lots?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function createFiberTransaction(body) {
  return fetch('/v3/fiber/transactions', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function fiberOutgoingTransactionGet(transactionId) {
  return fetch(`/v3/fiber/transactions/outgoings/${transactionId}`, {
    method: 'GET',
  });
}

export function fiberOutgoingTransactionsGet(queryParams) {
  return fetch(
    `/v3/fiber/transactions/outgoings?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function fiberIncomingTransactionGet(transactionId) {
  return fetch(`/v3/fiber/transactions/incomings/${transactionId}`, {
    method: 'GET',
  });
}

export function fiberIncomingTransactionsGet(queryParams) {
  return fetch(
    `/v3/fiber/transactions/incomings?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function fiberProductionProcessCreate(body) {
  return fetch('/v3/fiber/production-processes', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function fiberProductionProcessesGet(queryParams) {
  return fetch(
    `/v3/fiber/production-processes?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function fiberProductionFactorsGet({
  productCategoryId,
  facilityProcessId,
}) {
  return fetch(
    `/v3/fiber/production-factors/${productCategoryId}?${getDefinedUrlSearchParams(
      {
        facilityProcessId,
      },
    )}`,
    {
      method: 'GET',
    },
  );
}

export function fiberProductionProcessGet(id) {
  return fetch(`/v3/fiber/production-processes/${id}`, {
    method: 'GET',
  });
}

export function fiberProductionProcessUpdate(id, body) {
  return fetch(`/v3/fiber/production-processes/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function fiberProductionProcessPatch(id, body) {
  return fetch(`/v3/fiber/production-processes/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function fiberProductionProcessCocModelsGet() {
  return fetch('/v3/fiber/production-processes/coc-models', {
    method: 'GET',
  });
}

export function fiberTransformationCreate(body) {
  return fetch('/v3/fiber/production-processes/transformations', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function fiberTransformationsGet(queryParams) {
  return fetch(
    `/v3/fiber/production-processes/transformations?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function fiberTransformationGet(id) {
  return fetch(`/v3/fiber/production-processes/transformations/${id}`, {
    method: 'GET',
  });
}

export function fiberProductionProcessTransformationDocumentsAttach(body) {
  return fetch(
    '/v3/fiber/production-processes/attach-transformation-documents',
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export function fiberProductionProcessTransformationDocumentsRemove(body) {
  return fetch(
    '/v3/fiber/production-processes/remove-transformation-documents',
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export function fiberProductsStocksGet(queryParams) {
  return fetch(
    `/v3/fiber/stocks/products?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function fiberArchivedLotsGet(queryParams) {
  return fetch(
    `/v3/fiber/lots/archived?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function fiberComponentsStocksGet(queryParams) {
  return fetch(
    `/v3/fiber/stocks/components?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function fiberProductStockLotsGet(id, queryParams) {
  return fetch(
    `/v3/fiber/stocks/lots/${id}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function fiberProductionProcessProductsByCocModelGet({
  fiberCocModelId,
  fiberProductionProcessId,
  isStockRequired,
  isOptional,
  isOutput,
}) {
  return fetch(
    `/v3/fiber/production-processes/products/${fiberCocModelId}?${getDefinedUrlSearchParams(
      {
        fiberProductionProcessId,
        isStockRequired,
        isOptional,
        isOutput,
      },
    )}`,
    {
      method: 'GET',
    },
  );
}

export function fiberStocksAvailableProducts({ isStockRequired }) {
  return fetch(
    `/v3/fiber/stocks/available-products?${getDefinedUrlSearchParams({
      isStockRequired,
    })}`,
    {
      method: 'GET',
    },
  );
}

export function fiberMatchReceivingProducts(incomingProductId) {
  return fetch(`/v3/fiber/transactions/matched-products/${incomingProductId}`, {
    method: 'GET',
  });
}

export function fiberTransactionsDocumentsAttach(body) {
  return fetch('/v3/fiber/transactions/attach-documents', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function fiberTransactionsDocumentsRemove(body) {
  return fetch('/v3/fiber/transactions/remove-document', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function fiberIncomingTransactionTracingGet(id) {
  return fetch(`/v3/fiber/transactions/incoming/${id}/tracing`, {
    method: 'GET',
  });
}

export function fiberOutgoingTransactionTracingGet(id) {
  return fetch(`/v3/fiber/transactions/outgoing/${id}/tracing`, {
    method: 'GET',
  });
}

export function fiberLotTracingGet(id) {
  return fetch(`/v3/fiber/lots/${id}/tracing`, {
    method: 'GET',
  });
}

export function fiberLinkTransactionsDetailsGet({ ids }) {
  return fetch(
    `/v3/fiber/transactions/transactions-by-link-ids?${getDefinedUrlSearchParams(
      {
        ids,
      },
    )}`,
    {
      method: 'GET',
    },
  );
}

export function fiberNodeDetailGet({ ids }) {
  return fetch(
    `/v3/fiber/transactions/nodes?${getDefinedUrlSearchParams({
      ids,
    })}`,
    {
      method: 'GET',
    },
  );
}

export function exportCompanies(id) {
  return fetch(`/v3/companies/export-esg-data/${id}`, {
    method: 'GET',
  });
}

export function patchPreferencesUnauthorized({ id, email }, body) {
  return fetch(
    `/v3/users/${id}/patch-preferences-unauthorized?email=${email}`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
    },
  );
}

export function productConsumerLifestagePatch(id, body) {
  return fetch(`/v3/products/${id}/consumer-lifestage`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function managementProductionProcessGet(id) {
  return fetch(`/v3/admin/production-processes/${id}`, {
    method: 'GET',
  });
}

export function managementProductionProcessUpdate(id, body) {
  return fetch(`/v3/admin/production-processes/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function checkSimilarTracingTemplates(body) {
  return fetch('/v3/cascade-tracing/orders/check-attachment-templates', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
export function bulkConvertComponentsToProducts(componentIds) {
  return fetch('/v3/products/bulk-convert-components-to-products', {
    method: 'PATCH',
    body: JSON.stringify(componentIds),
  });
}

export function managementFiberCocModelsGet(queryParams) {
  return fetch(
    `/v3/admin/fiber/coc-models?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function managementProductionFactorsGet(queryParams) {
  return fetch(
    `/v3/admin/fiber/production-factors?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function managementProductionFactorsPatch(id, body) {
  return fetch(`/v3/admin/fiber/production-factors/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function managementProductionFactorsCreate(body) {
  return fetch(
    '/v3/admin/fiber/production-factors/create-by-facility-processes',
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export function managementFiberCocModelPatch(id, body) {
  return fetch(`/v3/admin/fiber/coc-models/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function managementFiberSettingsGet() {
  return fetch('/v3/admin/fiber/settings', {
    method: 'GET',
  });
}

export function managementFiberSettingPatch(key, value) {
  return fetch('/v3/admin/fiber/settings', {
    method: 'PATCH',
    body: JSON.stringify({
      key,
      value,
    }),
  });
}

export function managementFiberProductionProcessesGet(queryParams) {
  return fetch(
    `/v3/admin/fiber/production-processes?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function managementFiberProductionProcessGet(id) {
  return fetch(`/v3/admin/fiber/production-processes/${id}`, {
    method: 'GET',
  });
}

export function managementFiberProductionProcessPatch(id, body) {
  return fetch(`/v3/admin/fiber/production-processes/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function managementFiberProductionProcessUpdate(id, body) {
  return fetch(`/v3/admin/fiber/production-processes/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function managementFiberProductionProcessCreate(body) {
  return fetch('/v3/admin/fiber/production-processes', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function managementFiberProductionFactorsGet({
  productCategoryId,
  facilityProcessId,
}) {
  return fetch(
    `/v3/admin/fiber/production-factors/${productCategoryId}?${getDefinedUrlSearchParams(
      {
        facilityProcessId,
      },
    )}`,
    {
      method: 'GET',
    },
  );
}

export function fiberSettingsGet() {
  return fetch('/v3/fiber/settings', {
    method: 'GET',
  });
}

export function getProductProperties(queryParams) {
  return fetch(
    `/v3/product-properties?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function createProductProperty(body) {
  return fetch('/v3/product-properties', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
export function cascadeTracingLinkSalesOrderByOrderNumber({
  purchaseOrderNumber,
  salesOrderNumber,
}) {
  return fetch('/v3/cascade-tracing/orders/link-sales-order-by-order-number', {
    method: 'POST',
    body: JSON.stringify({ purchaseOrderNumber, salesOrderNumber }),
  });
}

export function updateClassificationView(id, body) {
  return fetch(`/v3/classification/views/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function getClassificationView(
  { id, generator, dependencies = {} },
  fields = '',
) {
  const queryParams = fields ? `?fields=${fields}` : '';
  if (id)
    return fetch(`/v3/classification/views/${id}${queryParams}`, {
      method: 'GET',
    });

  return fetch(`/v3/classification/views${queryParams}`, {
    method: 'POST',
    body: JSON.stringify({ generator, dependencies }),
  });
}

export function createBulkLots(body) {
  return fetch('/v3/fiber/lots/bulk-create', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function verifyCertificateLicenseNumber(id) {
  return fetch(`/v3/claims/${id}/verify-license-number`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function managementVerifyCertificateLicenseNumber(id) {
  return fetch(`/v3/admin/claims/${id}/verify-license-number`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function patchClassificationDataFields(id, body) {
  return fetch(`/v3/admin/classification-data-fields/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function getCompanyDynamicTabsConfig(companyId) {
  return fetch(`/v3/admin/classification-company-dynamic-tabs/${companyId}`, {
    method: 'GET',
  });
}

export function setCompanyDynamicTabsConfig(companyId, body) {
  return fetch(`/v3/admin/classification-company-dynamic-tabs/${companyId}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function usersByCompanyId(companyId) {
  return fetch(`/v3/admin/users/list-by-company/${companyId}`, {
    method: 'GET',
  });
}

export function getUxConfig(pageName, queryParams) {
  return fetch(
    `/v3/ux-configs/${pageName}${queryParams ? `?${getDefinedUrlSearchParams(queryParams)}` : ''}`,
    {
      method: 'GET',
    },
  );
}

export function putUxConfig(pageName, configData, queryParams) {
  return fetch(
    `/v3/ux-configs/${pageName}${queryParams ? `?${getDefinedUrlSearchParams(queryParams)}` : ''}`,
    {
      method: 'PUT',
      body: JSON.stringify(configData),
    },
  );
}

export function getFieldsByCategoryId(categoryId, queryParams) {
  return fetch(
    `/v3/admin/classification-impact-areas/fields/${categoryId}${
      queryParams ? `?${getDefinedUrlSearchParams(queryParams)}` : ''
    }`,
    {
      method: 'GET',
    },
  );
}

export function getDocumentTypes(queryParams) {
  return fetch(
    `/v3/admin/document-types?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getDocumentTypesDropdown(queryParams) {
  return fetch(
    `/v3/document-types/drop-down?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function updateDocumentTypeUsage({ id, deprecate }) {
  return fetch(`/v3/admin/document-types/${id}/usage`, {
    method: 'PATCH',
    body: JSON.stringify({ deprecate }),
  });
}

export function deleteDocumentType({ id }) {
  return fetch(`/v3/admin/document-types/${id}`, {
    method: 'DELETE',
  });
}

export function createDocumentType(body) {
  return fetch('/v3/admin/document-types', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingExportBySalesOrderId(id) {
  return fetch(`/v3/cascade-tracing/orders/trace/sales/${id}/export`, {
    method: 'GET',
  });
}

export function getAdminTagsByCategory(category) {
  return fetch(`/v3/admin/admin-tags/category/${category}`, {
    method: 'GET',
  });
}

export function cascadeTracingExportByPurchaseOrderId(id) {
  return fetch(`/v3/cascade-tracing/orders/trace/purchases/${id}/export`, {
    method: 'GET',
  });
}

export function createAdminTag(body) {
  return fetch('/v3/admin/admin-tags', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function deleteCompanyDataField(id) {
  return fetch(`/v3/admin/company-data-fields/${id}`, {
    method: 'DELETE',
  });
}
export function patchDocumentType(id, body) {
  return fetch(`/v3/admin/document-types/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function getDocuments(queryParams) {
  return fetch(
    `/v3/admin/company-documents?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getArchivedDocuments(queryParams) {
  return fetch(
    `/v3/admin/company-documents-archived?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}
export function getCompanyDataFieldsData(queryParams) {
  return fetch(`/v3/data-fields?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function updateCompanyEsgData(body) {
  return fetch('/v3/data-fields', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function getCompanyDataFieldsStatistics(queryParams) {
  return fetch(
    `/v3/data-fields/statistics?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getTagsByCategory(category) {
  return fetch(`/v3/admin-tags/category/${category}`, {
    method: 'GET',
  });
}

export function getRules(queryParams) {
  return fetch(`/v3/admin/rules?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function updateRule({ id, body }) {
  return fetch(`/v3/admin/rules/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function deleteRule({ id }) {
  return fetch(`/v3/admin/rules/${id}`, {
    method: 'DELETE',
  });
}

export function createRule(body) {
  return fetch('/v3/admin/rules', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function getAuditsByAdmin(queryParams) {
  return fetch(`/v3/admin/audits?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function getArchivedAuditsByAdmin(queryParams) {
  return fetch(
    `/v3/admin/audits/archived?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getAuditTypes(queryParams) {
  return fetch(
    `/v3/admin/audit-types?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getIntroducedCompanies(companyId, queryParams) {
  return fetch(
    `/v3/supplier-network/${companyId}/introduced-companies?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function deleteAuditType({ id }) {
  return fetch(`/v3/admin/audit-types/${id}`, {
    method: 'DELETE',
  });
}
export function updateAuditTypeUsage({ id, deprecate }) {
  return fetch(`/v3/admin/audit-types/${id}/usage`, {
    method: 'PATCH',
    body: JSON.stringify({ deprecate }),
  });
}

export function createAuditType(body) {
  return fetch('/v3/admin/audit-types', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
export function createShareSupplierNetworks(body) {
  return fetch('/v3/supplier-network/share', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function patchAuditType(id, body) {
  return fetch(`/v3/admin/audit-types/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}
export function connectSupplierNetwork(body) {
  return fetch('/v3/supplier-network/connect', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function getSharedSuppliersWithMe(queryParams) {
  return fetch(
    `/v3/supplier-network/shared-with-me?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function requestSupplierNetwork(body) {
  return fetch('/v3/supplier-network/requests', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function getSupplierNetworkRequests(queryParams) {
  return fetch(
    `/v3/supplier-network/requests?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getIncompleteSupplierNetworkRequests(companyId) {
  return fetch(`/v3/supplier-network/requests/${companyId}/incomplete`, {
    method: 'GET',
  });
}

export function getAuditTypesDropdown(queryParams) {
  return fetch(
    `/v3/audit-types/drop-down?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function checkDynamicTabDuplicatedConfiguration(queryParams) {
  return fetch(
    `/v3/admin/classification-company-dynamic-tabs/duplication?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function cascadeTracingExportBySalesOrderIds(body) {
  return fetch('/v3/cascade-tracing/orders/trace/sales/bulk-export', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function getNetworkCompaniesGraph(queryParams) {
  return fetch(
    `/v3/network-companies/graph?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function createNetworkCompaniesGraph(body) {
  return fetch('/v3/network-companies/graph', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingExportByPurchaseOrderIds(body) {
  return fetch('/v3/cascade-tracing/orders/trace/purchase/bulk-export', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function createLinkNetworkCompaniesGraph(id, body) {
  return fetch(`/v3/network-companies/graph/${id}/links`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function deleteLinkNetworkCompaniesGraph(graphId, { linkId }) {
  return fetch(`/v3/network-companies/graph/${graphId}/links/${linkId}`, {
    method: 'DELETE',
    body: JSON.stringify({}),
  });
}

export function patchNetworkCompaniesNodes(id, body) {
  return fetch(`/v3/network-companies/graph/${id}/nodes`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function managementTagIdenficationPatch(tagIdentificationId, body) {
  return fetch(`/v3/admin/tag-identifications/${tagIdentificationId}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function managementTagIdenficationRemoveTag(tagId) {
  return fetch(`/v3/admin/tag-identifications/tagged/${tagId}`, {
    method: 'DELETE',
    body: JSON.stringify({}),
  });
}

export function tagIdentificationsAdminGet(queryParams) {
  return fetch(
    `/v3/admin/tag-identifications?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function materialsConstantMappingDelete(body) {
  return fetch('/v3/constants-mapping/materials', {
    method: 'DELETE',
    body: JSON.stringify(body),
  });
}

export function getMaterialsConstantMapping(queryParams) {
  return fetch(
    `/v3/constants-mapping/materials?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function materialsConstantMappingCreate(body) {
  return fetch('/v3/constants-mapping/materials', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function materialsConstantMappingPatch(id, body) {
  return fetch(`/v3/constants-mapping/materials/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function getProductCategoriesConstantMapping(queryParams) {
  return fetch(
    `/v3/constants-mapping/product-types?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function productCategoriesConstantMappingPatch(id, body) {
  return fetch(`/v3/constants-mapping/product-types/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function productCategoriesConstantMappingCreate(body) {
  return fetch('/v3/constants-mapping/product-types', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function productCategoriesConstantMappingDelete(body) {
  return fetch('/v3/constants-mapping/product-types', {
    method: 'DELETE',
    body: JSON.stringify(body),
  });
}

export function supplyChainExtend(id, body) {
  return fetch(`/v3/supply-chains/${id}/extend`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function supplyChainMappingGet(id, queryParams) {
  return fetch(
    `/v3/supply-chains/${id}?${getDefinedUrlSearchParams(queryParams)}`,
    {},
  );
}

export function supplyChainCompanyMappingGet(id, _queryParams) {
  return fetch(`/v3/supply-chains/${id}`, {
    method: 'GET',
  });
}

export function supplyChainMappingsCreate(body) {
  return fetch('/v3/supply-chains', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function supplyChainMappingsGet(queryParams) {
  return fetch(`/v3/supply-chains?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function supplyChainNodeDetailsGet(queryParams) {
  return fetch(
    `/v3/supply-chains/asset?${getDefinedUrlSearchParams(queryParams)}`,
    { method: 'GET' },
  );
}

export function supplyChainLinkDetailsGet(id, queryParams) {
  return fetch(
    `/v3/supply-chains/link/${id}?${getDefinedUrlSearchParams(queryParams)}`,
    { method: 'GET' },
  );
}

export function supplyChainMappingUpdate(id, body) {
  return fetch(`/v3/supply-chains/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function supplyChainLinkDetailUpdate(id, body) {
  return fetch(`/v3/supply-chains/links/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function supplyChainMappingNodeDelete(id, queryParams) {
  return fetch(
    `/v3/supply-chains/nodes/${id}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'DELETE',
    },
  );
}

export function productOrdersGet(id) {
  return fetch(`/v3/products/${id}/traced-orders`, {
    method: 'GET',
  });
}

export function assignDeepestOrdersAsProductStories(body, queryParams) {
  return fetch(
    `/v3/cascade-tracing/orders/product-stories-recalculation?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export function bulkUploadBOM(body) {
  return fetch('/v3/products/bulk-upload-bom', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function supplyChainsBulkArchive(supplyChainIds) {
  return fetch('/v3/supply-chains/archive', {
    method: 'POST',
    body: JSON.stringify(supplyChainIds),
  });
}

export function copySupplyChainMapping(body) {
  return fetch('/v3/supply-chains/copy', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function supplyChainFacilityProcessUpdate(nodeId, body) {
  return fetch(`/v3/supply-chains/nodes/${nodeId}/featured-facility-process`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function getRelationShipTypes(queryParams) {
  return fetch(
    `/v3/admin/relationship-types?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function createRelationShipType(body) {
  return fetch('/v3/admin/relationship-types', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function deleteRelationshipType(id) {
  return fetch(`/v3/admin/relationship-types/${id}`, {
    method: 'DELETE',
  });
}

export function updateRelationshipType(id, body) {
  return fetch(`/v3/admin/relationship-types/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function getCollaborationStatuses(queryParams) {
  return fetch(
    `/v3/admin/collaboration-statuses?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function createCollaborationStatus(body) {
  return fetch('/v3/admin/collaboration-statuses', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function updateCollaborationStatus(id, body) {
  return fetch(`/admin/collaboration-statuses/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function deleteCollaborationStatus(id) {
  return fetch(`/v3/admin/collaboration-statuses/${id}`, {
    method: 'DELETE',
  });
}

export function getUserCollaborationStatuses(queryParams) {
  return fetch(
    `/v3/collaboration-statuses?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getUserRelationShipTypes(queryParams) {
  return fetch(
    `/v3/relationship-types?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function acceptTerms(body) {
  return fetch('/v3/users/accept-terms', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function userCompanyPatchByAdmin(id, body) {
  return fetch(`/v3/admin/user-companies/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function userCompanyRemoveByAdmin(id) {
  return fetch(`/v3/admin/user-companies/${id}`, {
    method: 'DELETE',
  });
}

export function mePreferencesPatch(body) {
  return fetch('/v3/me/preferences', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function mePreferencesGet(queryParams) {
  return fetch(`/v3/me/preferences?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export function getByEmailShaUnauthorized(queryParams) {
  return fetch(
    `/v3/user-preferences/get-by-user-email-sha-unauthorized?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function userCompaniesListByCompanyIds(queryParams) {
  return fetch(
    `/v3/user-companies/list-by-company-ids?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function bulkRequestNetwork(body) {
  return fetch('/v3/supplier-network/bulk-requests', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function getInCompleteRequests(body) {
  return fetch('/v3/supplier-network/requests/incomplete', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function cascadeTracingDeleteOriginOrder(transactionId, body) {
  return fetch(`/v3/cascade-tracing/transactions/origin/${transactionId}`, {
    method: 'DELETE',
    body: JSON.stringify(body),
  });
}

export function productBackwardsMyFiles(queryParams) {
  return fetch(
    `/v3/cascade-tracing/documents/my-documents?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function productBackwardsDocumentPurchaseOrderDetailsGet(
  tracingDocumentId,
) {
  return fetch(
    `/v3/cascade-tracing/documents/${tracingDocumentId}/purchase-order`,
    {
      method: 'GET',
    },
  );
}

export function productBackwardsTracingDocumentDelete(body) {
  return fetch('/v3/cascade-tracing/documents', {
    method: 'DELETE',
    body: JSON.stringify(body),
  });
}

export function productBackwardsTracingDocumentStatisticsGet() {
  return fetch('/v3/cascade-tracing/documents/statistics', {
    method: 'GET',
  });
}

export function productBackwardsTracingDocumentReplace(body) {
  return fetch('/v3/cascade-tracing/documents/replace', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function filesWithAssetList(queryParams) {
  return fetch(
    `/v3/files/list-with-assets?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function fetchArticle(articleId) {
  return fetch(`/v3/intercom/articles/${articleId}`, {
    method: 'GET',
  });
}

export function networkCompaniesExport(body) {
  return fetch('/v3/companies/export', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function markCompaniesClient(body) {
  return fetch('/v3/admin/clients', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function removeCompaniesClient(body) {
  return fetch('/v3/admin/clients', {
    method: 'DELETE',
    body: JSON.stringify(body),
  });
}

export function adminDevelopmentFeatureTagsGet(queryParams) {
  return fetch(
    `/v3/admin/development-tags/list-feature-tags?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function adminDevelopmentTags(queryParams) {
  return fetch(
    `/v3/admin/development-tags?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getAttachmentTemplatesByOrderIds(type, queryParams) {
  return fetch(
    [
      `${getApiOrigin()}/api/attachment-templates/documents?${getDefinedUrlSearchParams({ ...queryParams, tracingType: type })}`,
    ],
    {
      method: 'GET',
    },
  );
}

export function productBackwardsUpdateMultiplePurchaseOrdersDocument(body) {
  return fetch(
    '/v3/cascade-tracing/orders/purchase-orders/bulk-documents-update',
    {
      method: 'PATCH',
      body: JSON.stringify(body),
    },
  );
}

export function productBackwardsUpdateMultipleSalesOrdersDocument(body) {
  return fetch(
    '/v3/cascade-tracing/orders/sales-orders/bulk-documents-update',
    {
      method: 'PATCH',
      body: JSON.stringify(body),
    },
  );
}

export function getProductsVendorsAndSuppliers() {
  return fetch('/v3/products/get-products-suppliers-vendors', {
    method: 'GET',
  });
}
